import { useLocation } from "react-router-dom";
import { StoryblokComponent, useStoryblok } from "@storyblok/react";
import { useDelayedLoading } from "../../helpers/useDelayedLoading";

type PageProps = {
  slug?: string;
};

const Page = ({ slug }: PageProps) => {
  const location = useLocation();
  const slugFromPath = location.pathname.replace(/^\/|\/$/g, "");
  const currentSlug = slug || slugFromPath || "home";

  const story = useStoryblok(currentSlug, { version: "draft" });
  // useStoryblok begint met een leeg object ({}), niet null/undefined, dus
  // we bepalen "geladen" aan de hand van story.content i.p.v. story zelf.
  const hasContent = Boolean(story?.content);
  const showLoading = useDelayedLoading(!hasContent, 200);
  const showNotFound = useDelayedLoading(!hasContent, 3000);

  if (!hasContent) {
    if (showNotFound) return <div>Pagina niet gevonden</div>;
    return showLoading ? <div>Loading...</div> : null;
  }

  return (
    <main className="px-4">
      {story.content.body?.map((blok: any) => (
        <StoryblokComponent blok={blok} key={blok._uid} />
      ))}
    </main>
  );
};

export default Page;
